var map = {
	"./freshwater/arapaima/4.jpg": "46fc",
	"./freshwater/beluga-sturgeon/4.jpg": "dc4c",
	"./freshwater/chinook-salmon/4.jpg": "328e",
	"./freshwater/goldfish/4.jpg": "6195",
	"./freshwater/koi-carp/4.jpg": "65f5",
	"./freshwater/red-bellied-piranha/4.jpg": "720e",
	"./freshwater/redtail-catfish/4.jpg": "8670",
	"./freshwater/smalltooth-sawfish/4.jpg": "41de",
	"./ocean/bottlenose-dolphin/4.jpg": "6eff",
	"./ocean/box-jellyfish/4.jpg": "4cad",
	"./ocean/giant-pacific-octopus/4.jpg": "35e7",
	"./ocean/gray-seal/4.jpg": "cbd3",
	"./ocean/green-sea-turtle/4.jpg": "226e",
	"./ocean/humboldt-penguin/4.jpg": "fe04",
	"./ocean/manta-ray/4.jpg": "8299",
	"./ocean/starfish/4.jpg": "7274",
	"./saltwater/atlantic-tarpon/4.jpg": "37e0",
	"./saltwater/butterflyfish/4.jpg": "719d",
	"./saltwater/clownfish/4.jpg": "5e6c",
	"./saltwater/emperor-angelfish/4.jpg": "6869",
	"./saltwater/hippo-tang/4.jpg": "3471",
	"./saltwater/longhorn-cowfish/4.jpg": "bfb8",
	"./saltwater/red-lionfish/4.jpg": "4bda",
	"./saltwater/yellow-surgeonfish/4.jpg": "94c5",
	"./shark/blacktip-shark/4.jpg": "042f",
	"./shark/bull-shark/4.jpg": "586f",
	"./shark/nurse-shark/4.jpg": "e919",
	"./shark/oceanic-whitetip-shark/4.jpg": "0b7c",
	"./shark/pelagic-thresher-shark/4.jpg": "0358",
	"./shark/scalloped-hammerhead-shark/4.jpg": "8efb",
	"./shark/whale-shark/4.jpg": "95fe",
	"./shark/zebra-shark/4.jpg": "387f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e485";